import React, { useState } from 'react';
import { startNewClient, clearSessionOnLogout } from '../utils/sessionManagerV2';
import { signOut } from 'aws-amplify/auth';

function Navigation({ activeView, onNavClick, onStartNewClient }) {
  const [isStartingNewClient, setIsStartingNewClient] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleStartNewClient = async () => {
    // Show confirmation dialog
    setShowConfirmDialog(true);
  };

  const confirmStartNewClient = async () => {
    try {
      setIsStartingNewClient(true);
      setShowConfirmDialog(false);

      // End current session and start fresh one
      await startNewClient();

      // Reset local UI state without clearing Cognito auth storage.
      if (onStartNewClient) {
        onStartNewClient();
      }
      setIsStartingNewClient(false);
    } catch (error) {
      console.error('Error starting new client:', error);
      alert('Failed to start new client session. Please try again.');
      setIsStartingNewClient(false);
    }
  };

  const handleLogout = async () => {
    try {
      // Clear session on server
      await clearSessionOnLogout();

      // Sign out from Cognito
      await signOut();
    } catch (error) {
      console.error('Error during logout:', error);
      // Continue with logout even if session clear fails
      try {
        await signOut();
      } catch (signOutError) {
        console.error('Error signing out:', signOutError);
      }
    }
  };

  return (
    <>
      <div className="flex border-b bg-gray-100 items-center justify-between px-2">
        <div className="flex">
          <button
            className={`px-4 py-2 ${
              activeView === 'workflow' ? 'font-bold bg-white border-t border-l border-r' : ''
            }`}
            onClick={() => onNavClick('workflow')}
          >
            AI Drafting Workflow
          </button>
          <button
            className={`px-4 py-2 ${
              activeView === 'knowledge' ? 'font-bold bg-white border-t border-l border-r' : ''
            }`}
            onClick={() => onNavClick('knowledge')}
          >
            Knowledge Base
          </button>
        </div>

        <div className="flex gap-2 items-center">
          <button
            onClick={handleStartNewClient}
            disabled={isStartingNewClient}
            className={`px-4 py-2 rounded font-medium ${
              isStartingNewClient
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
            title="End current session and start fresh for a new client"
          >
            {isStartingNewClient ? 'Starting...' : 'Start New Client'}
          </button>

          <button
            onClick={handleLogout}
            className="px-4 py-2 rounded font-medium bg-gray-600 text-white hover:bg-gray-700"
            title="Sign out and end session"
          >
            Logout
          </button>
        </div>
      </div>

      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md mx-4 shadow-xl">
            <h3 className="text-lg font-bold mb-3">Start New Client Session?</h3>
            <p className="text-gray-700 mb-4">
              This will end your current client session and start fresh for a new client without signing you out.
              Any unsaved work will be lost.
            </p>
            <p className="text-sm text-gray-600 mb-6">
              Make sure you've downloaded all documents before proceeding.
            </p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => setShowConfirmDialog(false)}
                className="px-4 py-2 rounded bg-gray-200 text-gray-800 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={confirmStartNewClient}
                className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
              >
                Yes, Start New Client
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Navigation;
